import React from 'react'

interface Props {
  children: React.ReactElement;
}

interface State {
}

class Heading extends React.Component<Props, State> {

  render() {
    return (  
      <header>
        {this.props.children}
      </header>
    );
  }
}

export default Heading;  
